<template>
    <v-card class="waitlist-card" elevation="0">
        <v-card-text class="pa-5 pa-md-6">
            <h2 class="text-h6 mb-2 primary--text">Nog geen aanbod voor {{ theme.value }}</h2>
            <p class="mb-5">
                Heb je belangstelling voor dit thema, meld je dan hier aan. Je krijgt dan een mailtje
                wanneer we aanbod op dit thema georganiseerd hebben.
            </p>

            <v-alert v-if="success" color="success" class="mb-0">
                Bedankt voor je aanmelding! We laten het je weten zodra er aanbod op dit thema is.
            </v-alert>
            <v-form v-else ref="form" @submit.prevent="submit" :disabled="submitting">
                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                    label="Naam" v-model="form.name" :rules="[requiredRule]"
                ></v-text-field>
                <v-text-field outlined rounded required hide-details="auto" class="mb-4"
                    label="E-mailadres" type="email" v-model="form.email" :rules="[requiredRule, emailRule]"
                ></v-text-field>
                <v-text-field outlined rounded hide-details="auto" class="mb-4"
                    label="School of schoolbestuur (optioneel)" v-model="form.school"
                ></v-text-field>
                <v-btn type="submit" color="primary" rounded class="elevation-0" :loading="submitting" :disabled="submitting">
                    Aanmelden
                </v-btn>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default {
    name: "WaitlistForm",
    props: {
        // Een (samengevoegde) keuze uit het thema-facet.
        theme: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        submitting: false,
        success: false,
        form: {
            name: null,
            email: null,
            school: null,
        },
        requiredRule: (value) => !!value || "Dit veld is verplicht.",
        emailRule: (value) => !!(!value || value.match(emailRegex)) || "Ongeldig e-mailadres.",
    }),
    watch: {
        // Bij een ander thema begint de bezoeker met een nieuwe aanmelding.
        'theme.id' () {
            this.success = false;
        },
    },
    methods: {
        submit() {
            if (!this.$refs.form.validate() || this.submitting) {
                return;
            }

            this.submitting = true;

            this.$store.dispatch('organisation/registerWaitlist', { theme: this.theme.id, ...this.form })
                .then(() => { this.success = true; })
                .catch(e => {
                    console.error(e);
                    this.$store.dispatch('showSnackbar', { color: 'error', text: 'De aanmelding kon niet worden verstuurd, controleer de invoer' });
                })
                .finally(() => { this.submitting = false; });
        },
    },
}
</script>

<style scoped>
.waitlist-card {
    border: 1px solid #e0e0e0;
}
</style>
